<script>
export default {
    data ()
    {
        return {
            isMounted: false
        }
    },

    render(createElement) {
        if (this.isMounted)
        {
            // if there are multiple nodes in the default slot
            if (this.$slots.default?.length > 1)
            {
                return createElement("div", this.$slots.default);
            }

            return this.$slots.default ? this.$slots.default : null;
        }
        // SSR-Phase: Platzhalter-Element rendern statt undefined
        // Dies verhindert HierarchyRequestError bei der Hydration
        return createElement("div", { class: "client-only-placeholder" });
    },
    mounted() {
        this.isMounted = true;
    }
}
</script>
